var map = {
	"./symbol_0.png": "000c",
	"./symbol_1.png": "a60c",
	"./symbol_2.png": "9d00",
	"./symbol_3.png": "b587",
	"./symbol_4.png": "36ee",
	"./symbol_5.png": "0933",
	"./symbol_6.png": "654a",
	"./symbol_7.png": "7d4a",
	"./symbol_8.png": "ff5f",
	"./symbol_9.png": "ff43"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9091";